<script setup lang="ts">
import type { SeoBaseProps } from "components/seo/Base.props"
import consola from "consola"

const route = useRoute()
const { locale } = useI18n()

const requestId = route.path + "_" + Date.now()

process.server &&
  consola.info(
    new Date().toISOString(),
    "Category page rendering start",
    route.path,
    requestId
  )

process.server &&
  consola.info(
    new Date().toISOString(),
    "Category page Gluon start",
    route.path,
    requestId
  )

const { data: pageData, error } = await usePage(
  `/api/gluon/fetchProductCategoryPage/${locale.value}/${route.params.category}/product_category.js`
)

process.server &&
  consola.info(
    new Date().toISOString(),
    "Category page Gluon end",
    route.path,
    requestId
  )

if (error.value) {
  process.server &&
    consola.error(
      new Date().toISOString(),
      "Product page error",
      "Error loading Gluon data",
      route.path,
      requestId,
      error.value
    )
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}

const loadPage = ref(
  isNaN(parseInt(route.params.page as string))
    ? 0
    : parseInt(route.params.page as string) - 1
)

const seoData = computed((): SeoBaseProps => {
  return {
    ...pageData.value?.seo,
    metaTitle:
      `${pageData.value?.seo.metaTitle} - Pagina ${route.params.page}` ??
      `${pageData.value?.pageInfo.mainTitle} - Pagina ${route.params.page}` ??
      undefined,
    metaDescription:
      `${pageData.value?.seo.metaDescription} - Pagina ${route.params.page}` ??
      undefined
  }
})
</script>

<template>
  <div class="category-page">
    <SeoBase v-bind="seoData" />
    <PagesCategory
      v-if="pageData"
      :page-info="pageData.pageInfo"
      :breadcrumbs="pageData.breadcrumbs"
      :load-page="loadPage"
    />
  </div>
</template>
